import {
  AccountEntry,
  AccountEntryStatus,
} from 'api/accountEntries/accountEntries.types';

export interface AllocationsTableData {
  id: number;
  job: string;
  counterparty: string;
  jobAmount: string;
  creationDate: string;
  status: AccountEntryStatus;
  jobId: number;
  allocationData: AccountEntry;
}

export interface AllocationHeadCell {
  id: keyof AllocationsTableData;
  label: string;
  numeric: boolean;
  align?: 'left' | 'center' | 'right' | 'justify' | 'inherit';
}

export enum AllocationStatus {
  PENDING = 'PENDING',
  ACCEPTED = 'ACCEPTED',
  REJECTED = 'REJECTED',
  REQUIRES_CORRECTION = 'REQUIRES_CORRECTION',
}

export enum JobStatus {
  IN_PROGRESS = 'IN_PROGRESS',
  FINALIZED = 'FINALIZED',
  BILLED = 'BILLED',
  CANCELLED = 'CANCELLED',
}
